export { default } from './ProfileEditPage';
export { default as template } from './profile-edit-page';
